<div
  class="d-flex align-items-center switch-checkbox"
  [class.disabled]="disabled"
  [class.hoverable]="hoverable && !hideCheckbox"
  (click)="onChange($event)"
  [id]="innerId"
>
  <label
    [ngbTooltip]="tooltip"
    [ngClass]="'switch switch-' + bsSize + ' switch-3d switch-' + bsClass"
    *ngIf="!hideCheckbox"
  >
    <input
      type="checkbox"
      class="switch-input"
      [checked]="checked"
      (change)="onChange($event)"
      [disabled]="disabled"
      [value]="value"
      [ngClass]="stylingClass"
    />
    <span class="switch-slider" [ngClass]="stylingClass"></span>
  </label>
  <span class="text" [class.text-muted]="disabled"
    ><ng-content></ng-content
  ></span>
</div>
